"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnlineUserLookup = void 0;
const client_1 = require("@apollo/client");
// TODO [S5-3302]: Rename to Online (along with `useOfflineDataLookup.ts`) when mobile/desktop offline strategy is implemented.
const useOnlineUserLookup = () => {
    const apolloClient = client_1.useApolloClient();
    const onlineLookup = (email, username) => {
        return apolloClient
            .query({
            query: client_1.gql `
          query userLookup { userLookup( filter: {
            ${email ? `email: "${email}",` : ''}
            ${username ? `username: "${username}",` : ''}
          }) {
            username,
            firstName,
            lastName,
            email,
            phoneNumber,
            isTgoAdmin,
            isSingleSignOnUser
          } }
        `,
            fetchPolicy: 'no-cache',
        })
            .then(res => { var _a, _b; return (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.userLookup) !== null && _b !== void 0 ? _b : null; });
    };
    return onlineLookup;
};
exports.useOnlineUserLookup = useOnlineUserLookup;
//# sourceMappingURL=useOnlineUserLookup.js.map